'use client';

import HeroSection from './HeroSection';
import CompanyStory from './CompanyStory';
import CompanyValues from './CompanyValues';
import CertificationsAwards from './CertificationsAwards';
import CTASection from './CTASection';

interface Milestone {
  year: string;
  title: string;
  description: string;
  icon: string;
}

interface Value {
  icon: string;
  title: string;
  description: string;
}

interface Certification {
  name: string;
  issuer: string;
  year: string;
  image: string;
  imageAlt: string;
}

interface Award {
  title: string;
  organization: string;
  year: string;
  description: string;
  icon: string;
}

export default function AboutInteractive() {
  const heroData = {
    title: "25 Yıllık Deneyim ile Güvenli Yapılar",
    subtitle: "Hakkımızda",
    description: "1999 yılından bu yana Türk inşaat sektöründe kalite, güven ve mükemmeliyetin simgesi. Her projede geleneksel Türk ustalığını modern teknoloji ile birleştirerek, hayallerinizi gerçeğe dönüştürüyoruz.",
    heroImage: "https://images.unsplash.com/photo-1516122525-233a985caa45",
    heroImageAlt: "Modern construction site with steel framework and workers in safety gear against blue sky"
  };

  const milestones: Milestone[] = [
  {
    year: "1999",
    title: "Kuruluş",
    description: "Subaylar İnşaat, küçük bir ekip ve büyük hayallerle İstanbul'da kuruldu. İlk projemizde gösterdiğimiz kalite ve titizlik, bugünkü başarımızın temelini attı.",
    icon: "RocketLaunchIcon"
  },
  {
    year: "2005",
    title: "İlk Büyük Proje",
    description: "50 daireli ilk büyük konut projemizi başarıyla tamamladık. Bu proje, sektördeki güvenilirliğimizi pekiştirdi ve yeni fırsatların kapısını açtı.",
    icon: "BuildingOffice2Icon"
  },
  {
    year: "2010",
    title: "ISO Sertifikasyonu",
    description: "Kalite yönetim sistemimiz ISO 9001 sertifikası ile tescillendi. Uluslararası standartlara uygun çalışma prensibimiz resmi olarak onaylandı.",
    icon: "ShieldCheckIcon"
  },
  {
    year: "2015",
    title: "Ticari Projelere Geçiş",
    description: "Konut projelerindeki başarımızı ticari alana taşıdık. İlk alışveriş merkezi projemizi zamanında ve bütçe dahilinde tamamladık.",
    icon: "BuildingStorefrontIcon"
  },
  {
    year: "2020",
    title: "Dijital Dönüşüm",
    description: "BIM teknolojisi ve dijital proje yönetim sistemlerini entegre ettik. Müşterilerimize gerçek zamanlı proje takibi imkanı sunduk.",
    icon: "ComputerDesktopIcon"
  },
  {
    year: "2024",
    title: "Sürdürülebilir İnşaat",
    description: "Çevre dostu malzemeler ve enerji verimli tasarımlarla sürdürülebilir inşaat alanında öncü olduk. LEED sertifikalı ilk projemizi tamamladık.",
    icon: "SparklesIcon"
  }];


  const values: Value[] = [
  {
    icon: "ShieldCheckIcon",
    title: "Güvenilirlik",
    description: "25 yıldır verdiğimiz sözleri tutuyoruz. Her projede aynı titizlik ve sorumluluk bilinciyle çalışıyoruz."
  },
  {
    icon: "StarIcon",
    title: "Kalite",
    description: "En iyi malzemeler, en deneyimli ekip ve en sıkı kontroller. Kaliteden asla ödün vermiyoruz."
  },
  {
    icon: "ClockIcon",
    title: "Zamanında Teslimat",
    description: "Planlanan tarihlere sadık kalıyoruz. Projelerimizin %95'ini zamanında teslim ediyoruz."
  },
  {
    icon: "HeartIcon",
    title: "Müşteri Memnuniyeti",
    description: "Müşterilerimizin beklentilerini aşmak için çalışıyoruz. Memnuniyet oranımız %98'in üzerinde."
  }];


  const certifications: Certification[] = [
  {
    name: "ISO 9001",
    issuer: "Kalite Yönetim Sistemi",
    year: "2010",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13cb60122-1764646558400.png",
    imageAlt: "ISO 9001 quality management system certification badge with blue and white design"
  },
  {
    name: "ISO 14001",
    issuer: "Çevre Yönetim Sistemi",
    year: "2015",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17ab5d948-1764657835872.png",
    imageAlt: "ISO 14001 environmental management certification logo with green earth symbol"
  },
  {
    name: "ISO 45001",
    issuer: "İş Sağlığı ve Güvenliği",
    year: "2018",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fc331da2-1764657834545.png",
    imageAlt: "ISO 45001 occupational health and safety certification emblem with protective shield icon"
  },
  {
    name: "LEED",
    issuer: "Yeşil Bina Sertifikası",
    year: "2020",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1230e0181-1764638984544.png",
    imageAlt: "LEED green building certification logo with leaf and building design in green"
  },
  {
    name: "TSE",
    issuer: "Türk Standartları Enstitüsü",
    year: "2008",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e49e8ad7-1767354105125.png",
    imageAlt: "Turkish Standards Institute TSE certification mark with red and white colors"
  },
  {
    name: "İMO",
    issuer: "İnşaat Mühendisleri Odası",
    year: "1999",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d14a30ee-1769463279846.png",
    imageAlt: "Chamber of Civil Engineers membership certificate badge with professional emblem"
  }];


  const awards: Award[] = [
  {
    title: "Yılın İnşaat Firması",
    organization: "Türkiye İnşaat Sanayicileri İşveren Sendikası",
    year: "2023",
    description: "Kalite, güvenlik ve müşteri memnuniyeti alanlarındaki üstün performansımız ile sektörün en prestijli ödülüne layık görüldük.",
    icon: "TrophyIcon"
  },
  {
    title: "Sürdürülebilir İnşaat Ödülü",
    organization: "Çevre ve Şehircilik Bakanlığı",
    year: "2022",
    description: "Çevre dostu malzemeler ve enerji verimli tasarımlarımızla sürdürülebilir inşaat alanındaki öncülüğümüz ödüllendirildi.",
    icon: "SparklesIcon"
  },
  {
    title: "Müşteri Memnuniyeti Ödülü",
    organization: "Türkiye Kalite Derneği",
    year: "2021",
    description: "%98 müşteri memnuniyet oranımız ve müşteri odaklı hizmet anlayışımız ile bu ödülü kazandık.",
    icon: "HeartIcon"
  }];


  return (
    <>
      <HeroSection data-component-id="src/app/about/components/AboutInteractive.tsx:180:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="180" data-component-end-line="180" data-component-file="AboutInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...heroData} />
      <CompanyStory data-component-id="src/app/about/components/AboutInteractive.tsx:181:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="181" data-component-end-line="181" data-component-file="AboutInteractive.tsx" data-component-name="CompanyStory" data-component-content="%7B%22elementName%22%3A%22CompanyStory%22%7D" milestones={milestones} />
      <CompanyValues data-component-id="src/app/about/components/AboutInteractive.tsx:182:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="182" data-component-end-line="182" data-component-file="AboutInteractive.tsx" data-component-name="CompanyValues" data-component-content="%7B%22elementName%22%3A%22CompanyValues%22%7D" values={values} />
      <CertificationsAwards data-component-id="src/app/about/components/AboutInteractive.tsx:183:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="183" data-component-end-line="183" data-component-file="AboutInteractive.tsx" data-component-name="CertificationsAwards" data-component-content="%7B%22elementName%22%3A%22CertificationsAwards%22%7D" certifications={certifications} awards={awards} />
      <CTASection data-component-id="src/app/about/components/AboutInteractive.tsx:184:6" data-component-path="src/app/about/components/AboutInteractive.tsx" data-component-line="184" data-component-end-line="184" data-component-file="AboutInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
    </>);

}